import { Component, OnInit } from '@angular/core';
import { URLs } from '../../../constants/URLS';
import { AnalyticsService } from '../../../services/analytics.service';
import { AuthGuard } from '../../../guard/auth.guard';
import { CONFIG } from '../../../constants/lottie.constants';
import { ERRORES } from '../../../constants/errores.constants';
import { Router } from '@angular/router';
import { CallEquifaxService } from '../../../services/call-equifax.service';

@Component({
  selector: 'app-mensaje-cliente-existe',
  templateUrl: './mensaje-cliente-existe.component.html',
  styleUrls: ['./mensaje-cliente-existe.component.scss']
})
export class MensajeClienteExisteComponent implements OnInit {
  public window = window;
  configClienteExiste = ERRORES['cliente-existe'];
  lottieInfo = CONFIG.WARN;
  private readonly state: any = undefined;
  errorServicioEquifax: string;
  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly authGuard: AuthGuard,
    private readonly router: Router,
    private readonly callEquifaxService: CallEquifaxService
  ) {
    this.authGuard.setActivated = false;
    this.state = this.router.getCurrentNavigation().extras.state;
  }
  ngOnInit() {
    this.analyticsService.mensaje({
      label: 'segun nuestros registros ya eres cliente',
      action: 'view',
      channel: 'browser',
      element_id: undefined,
      type: 'alert warning',
      section: 'inicio'
    });
  }
  toggleActive() {
    this.window.location.href = URLs.portalLogin;
  }
  async continueAsGuess() {
    this.authGuard.setActivated = true;
    this.errorServicioEquifax =
      await this.callEquifaxService.setSecurityQuestions(
        this.state.rutSinPunto,
        this.state.encryptedCedula
      );
  }
}
